var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"more-content-button button-layout button-secondary button-small",on:{"click":_vm.next}},[_vm._t("default",function(){return [_vm._v("\n    More Content\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }